export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10319.21b9e84c.jpg";